import { axios } from '@/utils/axios'

/**
 * 国际票预约相关接口
 */

export async function fetchGjpReservList (params) {
  try {
    return await axios.post('/api/gjpReserv/list', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function fetchGjpReservSegList (params) {
  try {
    return await axios.post('/api/gjpReserv/segList', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function submitGjpReservPlace (params) {
  try {
    return await axios.post('/api/gjpReserv/place', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function fetchGjpReservDetail (params) {
  try {
    return await axios.post('/api/gjpReserv/detail', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function doGjpReservCancel (params) {
  try {
    return await axios.post('/api/gjpReserv/cancel', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
